import { render, staticRenderFns } from "./SiderSubMenu.vue?vue&type=template&id=06c3273b&"
import script from "./SiderSubMenu.vue?vue&type=script&lang=js&"
export * from "./SiderSubMenu.vue?vue&type=script&lang=js&"
import style0 from "./SiderSubMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports